import { render, staticRenderFns } from "./ManuscriptEditorMenuDialog.vue?vue&type=template&id=055a4c16&scoped=true"
import script from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
export * from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptEditorMenuDialog.vue?vue&type=style&index=0&id=055a4c16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a4c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055a4c16')) {
      api.createRecord('055a4c16', component.options)
    } else {
      api.reload('055a4c16', component.options)
    }
    module.hot.accept("./ManuscriptEditorMenuDialog.vue?vue&type=template&id=055a4c16&scoped=true", function () {
      api.rerender('055a4c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/ManuscriptEditorMenuDialog.vue"
export default component.exports